export default __webpack_public_path__ + "static/media/MOGL_Evivve_Certificates_Template.92b05870.pdf";